import type { SdkNotificationRecipient } from '@Pages/pageRuntime/sdk/types';

type LegacyRecipientFields = { resource_id?: unknown; record_id?: unknown };

/**
 * Published pages can still pass the earlier `resource_id`/`record_id` pair. Convert a
 * complete pair to `recipient`. Leave all other input unchanged for API validation.
 */
export function withNotificationRecipient<T extends { recipient?: SdkNotificationRecipient }>(
  input: T
): T {
  const {
    resource_id: resourceId,
    record_id: recordId,
    ...rest
  } = input as T & LegacyRecipientFields;
  if ('recipient' in input || typeof resourceId !== 'string' || typeof recordId !== 'string') {
    return input;
  }

  return { ...rest, recipient: { id: recordId, resource_id: resourceId } } as unknown as T;
}
